import { CUSTOMER_SEGMENTATION_SPECIFIC_DIMENSIONS, sanitizeValueToI18nKey } from '@carrefour-gcs/shared';

const CUSTOMER_SEGMENTATION_COLUMNS: readonly string[] = CUSTOMER_SEGMENTATION_SPECIFIC_DIMENSIONS;

export function isCustomerSegmentationColumn(columnName: string): boolean {
  return CUSTOMER_SEGMENTATION_COLUMNS.includes(columnName);
}

function translateCustomerSegmentationValue(t: (key: string) => string, columnName: string, rawValue: string): string {
  const key = sanitizeValueToI18nKey(rawValue);
  const [, segType, segGranularity] = columnName.split('_');
  const specificKey = `customerSegmentation.segments.${segType}.${segGranularity}.${key}`;
  const specificTranslation = t(specificKey);
  if (specificTranslation !== specificKey) {
    return specificTranslation;
  }
  const genericKey = `customerSegmentation.segments.${key}`;
  const genericTranslation = t(genericKey);
  if (genericTranslation !== genericKey) {
    return genericTranslation;
  }
  return rawValue;
}

export function translateDimensionCellText(t: (key: string) => string, columnName: string, rawTexts: string[]): string {
  return rawTexts
    .map((text) => t(text))
    .map((text) =>
      isCustomerSegmentationColumn(columnName) ? translateCustomerSegmentationValue(t, columnName, text) : text
    )
    .join('\n');
}
